import React from "react";
import { Snackbar, Alert } from "@mui/material";

export default function SnackbarAlert({ snackbar, setSnackbar }) {
  const handleClose = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Snackbar
      open={snackbar.open}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert
        onClose={handleClose}
        severity={snackbar.severity}
        variant="filled"
        sx={{ width: "100%" }}
        aria-live="polite"
      >
        {snackbar.message}
      </Alert>
    </Snackbar>
  );
}